import React, {useState, useEffect, useContext} from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";

import ArrowBack from "../../node_modules/@material-ui/icons/ArrowBack";
import apiFetch, {getData} from '../utils/apiUtils';
import { DropdownContext, ErrorContext } from '../utils/constants';

import DashboardFooter from '../components/DashboardFooter';
import EnhancedTextInput from '../components/EnhancedTextInput';
import ColoredSwitch from '../components/ColoredSwitch';
import Color from "../utils/colors";

const useStyles = makeStyles(() => ({
  h1: {
    marginBottom: '5px'
  },
  explaination: {
    fontSize: '30px',
  },
  btnClass: {
    backgroundColor: Color.darkBlue,
  },
  root: {
    display: 'flex',
  },
  main: {
    paddingRight: '10%',
    paddingLeft: '10%',
    paddingTop: '60px',
    width: '100%'
  },
  step: {
    fontSize: '24px',
    lineHeight: '28px',
    paddingBottom: '1rem'
  },
  description: {
    fontSize: '16px',
    lineHeight: '28px'
  },
  stepRoot: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  stepContainer: {
    paddingRight: '2rem',
    width: '66%',
    paddingTop: '2rem'
  },
  helpContainer: {
    marginTop: '2rem',
    padding: '5%',
    width: '33%',
    background: 'rgba(110, 247, 138, 0.1)',
  },

  inputStyle: {
    width: '100%',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: Color.primary,
    padding: '10px 12px',
    fontSize: '16px',
    transition: 'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    backgroundColor: 'white',
  },
  btnDiv: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '5rem',
    paddingBottom: '5rem',
  },
  error: {
    display: 'none',
    color: 'red',
    fontSize: '20px',
    paddingTop: '1rem'
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '20px'
  },
  switchGrid: {
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const helpText = {
  overview: 'At a high level, what are you trying to accomplish with this initiative?',
  current: 'What would someone need to know about your work to understand what you are trying to change?',
  current2:
    'Try to describe how things are currently done, what can be improved by changing how things are done, and what needs to change to get there. ',
  name: 'A initiative name should reference what the initiative is, and which transalta site/equipment it affects. Initiative names should not contain years or hashtags.',

  workstream: 'Picking a workstream helps to ensure that this initiative gets seen by the right approvers and determines which Workstream Lead will work with you on delivering this initiative.',
  classification: 'Initiatives with a Recurring or One-Time value greater than $50K, complex in nature, and/or cross-functional should be marked as Transformation.',
  visibility: 'Initiatives that deal with sensitive information, particularly salaries, wages, or staffing levels should be marked as confidential. Visibility of these initiatives will limited to the owner, relevant managers, and approvers.\n' +
    '\n' +
    'Visibility can be adjusted later in the initiative settings.',
};

function Step({stepName, children, style}) {
  const classes = useStyles();
  return (
    <div className={classes.stepContainer} style={{...style}}>
      <div className={classes.step}>
        {stepName}
      </div>
      {children}
    </div>
  );
}

export default function CreateInitiative() {
  const classes = useStyles();
  const history = useHistory();
  const { triggerError } = useContext(ErrorContext);

  // State
  const [ confidential, setConfidential ] = useState(false);
  const [ validate, setValidate ] = useState(false);
  const [ workstream, setWorkstream ] = useState('');
  const [ classification, setClassification ] = useState('');
  const [ overview, setOverview  ] = useState('');
  const [ current, setCurrent ] = useState('');
  const [ future, setFuture ] = useState('');
  const [ bridge, setBridge ] = useState('');
  const [ name, setName ] = useState('');
  const [ createBtnDisabled, setCreateBtnDisabled ] = useState(false);

  const [ workstreamList, setWorkstreamList ] = useState([]);
  const classificationList = useContext(DropdownContext).dropdowns['InitiativeClassification'];
  const { dropdownValues } = useContext(DropdownContext);

  const onErr = () => triggerError({
    title: 'Communication Error',
    description: 'We were unable to read template data from the server. Please try again.',
    onRetry: () => window.location.reload(),
  });

  useEffect(() => {
    getData('/generaldata/workstreams', (list) => { 
      setWorkstreamList(list.filter(ws => !ws.is_disabled));
    }, onErr);
    document.title = 'Rise by TransAlta Create Initiatives';
  }, []);

  // Methods
  const handleBackButton = () => {
    history.goBack();
  };

  const handleVisibityChange = event => {
    setConfidential(event.target.checked);
  };

  const handleWorkstreamChange = event => {
    setWorkstream(event.target.value);
  };

  const handleClassificationChange = event => {
    setClassification(event.target.value);
  };

  const handleChange = (method) => value => {
    method(value);
  };

  const handleCreateBtn = () => {
    if (!workstream || !overview || !current || !future || !bridge || !name || !classification) {
      document.getElementById('error-div').style.display='block';
      document.getElementById('error-div-end').style.display='block';
      setValidate(true);
      return;
    }

    let confidentialValue;
    if (confidential) {
      confidentialValue = dropdownValues.filter(item => item.value === 'Confidential')[0].id;
    } else {
      confidentialValue = dropdownValues.filter(item => item.value === 'Non-Confidential')[0].id;
    }
    const initiativeData = {
      classification,
      workstream,
      overview,
      current,
      future,
      bridge,
      name,
      confidential: confidentialValue
    };

    const doCreate = () => {
      setCreateBtnDisabled(true);
      apiFetch('/initiatives', 'POST', JSON.stringify(initiativeData),
        data => {
          history.push('/ui/initiativecard/' + data[0].id);
        },
        (error) => {
          triggerError({
            title: 'Communication Error',
            description: 'We were unable to save your initiative. Please try again.',
            onRetry: doCreate
          });
          setCreateBtnDisabled(false);
        });
    };
    doCreate();
  };

  // JSX
  const step1 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 1: Share your idea">
            <div className={classes.description}> In a couple sentences, what is your idea?</div>
            <EnhancedTextInput
              maxText={255}
              validate={validate}
              changeMethod={handleChange(setOverview)}
              placeholder="My idea is...."
              autoFocus={true}
              initialValue={overview}
              />
          </Step>
        <div className={classes.helpContainer}>
          {helpText.overview}
        </div>
    </div>
    )
  };

  const step2 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 2: Describe your idea">
          <div className={classes.description}> In describing your idea, what is the current state?</div>
          <EnhancedTextInput
            maxText={4000}
            validate={validate}
            placeholder="Currently we...."
            changeMethod={handleChange(setCurrent)}
            initialValue={current}
          />
          <div className={classes.description}> What is the future state and how do we get there? Why is this future state better?</div>
          <EnhancedTextInput
            maxText={4000}
            validate={validate}
            placeholder="In the future we will...."
            changeMethod={handleChange(setFuture)}
            initialValue={future}
          />
          <div className={classes.description}> How do we get from the current state to the future state?</div>
          <EnhancedTextInput
            maxText={4000}
            validate={validate}
            placeholder="We will bridge the gap by...."
            changeMethod={handleChange(setBridge)}
            initialValue={bridge}
          />
        </Step>
        <div className={classes.helpContainer}>
          {helpText.current}
          <br/>
          {helpText.current2}
        </div>
      </div>
    );
  };

  const step3 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 3: Name the initiative" style={{paddingTop: '4rem'}}>
          <div className={classes.description}> What is the name of this initiative? Please be clear and concise.</div>
          <EnhancedTextInput
            maxText={255}
            validate={validate}
            placeholder="Initiative name...."
            changeMethod={handleChange(setName)}
            initialValue={name}
          />
      </Step>
      <div className={classes.helpContainer}>
        {helpText.name}
      </div>
    </div>
    )};

  const step4 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 4: Workstream">
          <div className={classes.description}> What area of the company does this primarily affect?</div>
          <Select
            id="select-outlined"
            value={workstream}
            onChange={handleWorkstreamChange}
            className={classes.inputStyle}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {
              workstreamList.map((list) => {
               return (
                 <MenuItem value={list.id} key={'workstream-' + list.id}>{list.name}</MenuItem>
               )}
            )}
          </Select>
        </Step>
        <div className={classes.helpContainer}>
          {helpText.workstream}
        </div>
      </div>
    )};

  const step5 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 5: Classification">
          <div className={classes.description}> Is this a Transformation or Continuous Improvement initiative?</div>
          <Select
            id="select-outlined"
            value={classification}
            onChange={handleClassificationChange}
            className={classes.inputStyle}
          >
            {
              Object.keys(classificationList || {}).map(key => {
                const value = classificationList[key];
                return (<MenuItem value={key} key={'classification-' + key}>{value}</MenuItem>);
              })
            }
          </Select>
        </Step>
        <div className={classes.helpContainer}>
          {helpText.classification}
        </div>
    </div>
    );
  };

  const step6 = () => {
    return (
      <div className={classes.stepRoot}>
        <Step stepName="Step 6: Initiative Visibility">
          <div className={classes.description}> Does this initiative deal with sensitive information such as salaries, wages, or potentially a staff reduction?</div>
          <div className={classes.switchContainer}>
            <Grid component="label" container className={classes.switchGrid}>
              <Grid item>No</Grid>
              <Grid item>
                <ColoredSwitch
                  size='normal'
                  onChange={handleVisibityChange}
                  value={confidential}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                />
              </Grid>
              <Grid item>Yes</Grid>
            </Grid>
          </div>
        </Step>
        <div className={classes.helpContainer}>
          {helpText.visibility}
        </div>
    </div>
    );
  };

  return (
    <div className={classes.root} id="body-container">
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleBackButton}
            className={classes.menuButton}
          >
            <ArrowBack />
          </IconButton>
        </Toolbar>
      </AppBar>

      <main className={classes.main}>
        <h1 className={classes.h1}>Create a new initiative</h1>
        Let's walk through a few steps to set up your initiative.
        <div className={classes.error} id="error-div">You must fill in all the fields!</div>
        {step1()}
        {step2()}
        {step3()}
        {step4()}
        {step5()}
        {step6()}
        <div className={classes.error} id="error-div-end">You must fill in all the fields!</div>
        <div className={classes.btnDiv}>
          <Button variant="contained"
                  color="primary"
                  className={classes.btnClass}
                  onClick={handleCreateBtn}
                  disabled={createBtnDisabled}
          >
            CREATE INITIATIVE
          </Button>
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
}
